import styled from 'styled-components'
import { Modal } from './modals/Modal'
import { Title3, BodyLarge } from './styles/Typography'
import { OnClickButton } from './buttons/onclick/OnClickButton'
import { useNavigate } from 'react-router-dom'
import { theme } from '../theme/theme'
import { useTranslation } from 'react-i18next'

interface Props {
  onClose: () => void
  onConfirm?: () => void
  path?: string
  courseTitle?: string
}

export const CloseTrainingModal = ({ onClose, onConfirm, path }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleConfirm = () => {
    onConfirm && onConfirm()
    path && navigate(path)
  }
  return (
    <Modal onClose={onClose}>
      <ContentContainer>
        <Title3>{t('common.training.confirmCancel')}</Title3>
        <StyledBodyLarge>{t('common.training.progressNotSaved')} </StyledBodyLarge>
        <ButtonContainer>
          <OnClickButton text={t('common.training.continueTraining')} onClick={onClose} />
          <OnClickButton text={t('common.training.cancelAndLeave')} onClick={handleConfirm} secondary />
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
  justify-content: center;
  max-width: 400px;
  text-align: center;

  h3 {
    margin-top: ${theme.spacing.medium}px;
  }
`

const StyledBodyLarge = styled(BodyLarge)`
  margin-top: ${theme.spacing.mediumLarge}px;
  margin-bottom: ${theme.spacing.large}px;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  button {
    &:first-child {
      margin-bottom: ${theme.spacing.medium}px;
    }
  }
`
